// src/components/StartUmleitung.tsx
// „/“ leitet in den geführten Ablauf weiter (siehe lib/startZiel.ts). Übernimmt außerdem den
// früheren Dashboard-Sprung zum Checkout nach frischer Registrierung (pending_checkout_plan).
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "@clerk/clerk-react";
import { useUserPlan } from "../hooks/useUserPlan";
import { startZiel } from "../lib/startZiel";

export function StartUmleitung({ ladeanzeige }: { ladeanzeige: React.ReactNode }) {
  const { isLoaded, isSignedIn, user } = useUser();
  const { plan } = useUserPlan();
  const location = useLocation();

  React.useEffect(() => {
    if (!isSignedIn || !user || plan === "pro") return;
    let pendingPlan: string | null = null;
    let pendingInterval = "yearly";
    try {
      pendingPlan = sessionStorage.getItem("pending_checkout_plan");
      pendingInterval = sessionStorage.getItem("pending_checkout_interval") || "yearly";
    } catch { /* ohne Speicher kein Sprung */ }
    const ageMs = Date.now() - new Date(user.createdAt!).getTime();
    if (pendingPlan && ageMs < 300_000) {
      try {
        sessionStorage.removeItem("pending_checkout_plan");
        sessionStorage.removeItem("pending_checkout_interval");
      } catch { /* egal */ }
      window.location.href = `/checkout?plan=${pendingPlan}&interval=${pendingInterval}`;
    }
  }, [isSignedIn, user, plan]);

  const z = startZiel({
    clerkGeladen: isLoaded,
    eingeloggt: !!isSignedIn,
    search: location.search,
  });
  if (z.art === "warten") return <>{ladeanzeige}</>;
  return <Navigate to={z.pfad} replace />;
}
